// Names are not based on conventions :P They are there for easier identification of colors

export const pastelExcelBased = {
  base: [
    '#b5d2ec' // pastel Blue
  ],
  stress: [
    '#ffe38c', // pastel Yellow
    '#f4b183', // pastel Orange
    '#a5a5a5' // dark Gray
  ]
};
export const colorPalettes = {
  originalFrontend: ['#a7c5e5', '#d39fe9', '#e9e19f', '#9a75ff', '#a7e5b4', '#adb1c7', '#fa8d8d', '#ffc375'],
  pastelExcelBased,
  pastel_01: {
    base: [
      ...pastelExcelBased.base,
      '#c8e7ed', // light sky blue
      '#698ebc', // child blue
      '#69b1ce', // dreamer blue
      '#536b7c', // safe blue
      '#5e7c9e' // super bored blue
    ],
    stress: [
      // ! Avoid using similar colors as pass and fail colors (they are #ffc0cb && #c6efce)
      ...pastelExcelBased.stress,
      '#f18c8e', // heated pastel red
      '#ffcf96', // pastel orange
      '#f1d1b5', // pale skin
      '#fcbca6', // heated skin
      '#dab8a5', // light brown
      '#d3d3d3', // light gray
      '#f9ebbd', // lighter yellow
      '#9dbf89', // dark Green
      '#f9d9f9', // lighter purple
      '#cf9fff', // darker purple
      '#dbdbb7' // the yellow-brown's ugly child
    ]
  },
  material: {
    base: [
      // --- INDIGO ---
      '#7986CB', // 300
      '#303F9F', // 700
      '#1A237E', // 900
      '#8C9EFF', // A100
      '#304FFE', // A700
      // --- BLUE ---
      '#BBDEFB', // 100
      '#0D47A1', // 900
      '#82B1FF', // A100
      '#2962FF', // A700
      // --- LIGHT BLUE ---
      '#B3E5FC', // 100
      '#01579B', // 900
      '#80D8FF', // A100
      '#0091EA', // A700
      // --- CYAN ---
      '#B2EBF2', // 100
      '#006064', // 900
      '#84FFFF', // A100
      '#00B8D4' // A700
    ],
    stress: []
  },
  materialCherryPicked: {
    base: [
      // --- INDIGO ---
      '#1A237E', // 900
      '#8C9EFF', // A100
      '#304FFE', // A700
      // --- BLUE ---
      '#82B1FF', // A100
      // --- LIGHT BLUE ---
      '#01579B', // 900
      '#80D8FF', // A100
      '#0091EA', // A700
      // --- CYAN ---
      '#84FFFF', // A100
      '#00B8D4', // A700
      // --- OTHERS ---
      '#2b495e',
      '#004964',
      '#001264',
      '#015287',
      '#3e586b'
    ],
    stress: [
      // --- RED ---
      '#B71C1C', // 900
      '#FF8A80', // A100
      // --- PINK ---
      '#880E4F', // 900
      '#FF80AB', // A100
      // --- PURPLE ---
      '#4A148C', // 900
      '#EA80FC', // A100
      // --- DEEP PURPLE ---
      '#311B92', // 900
      '#B388FF', // A100
      // --- TEAL ---
      '#004D40', // 900
      '#A7FFEB', // A100
      // --- GREEN ---
      '#1B5E20', // 900
      '#B9F6CA', // A100
      // --- LIME ---
      '#33691E', // 900
      '#CCFF90', // A100
      // --- YELLOW ---
      '#F57F17', // 900
      '#FFFF8D', // A100
      // --- AMBER ---
      '#FF6F00', // 900
      '#FFE57F', // A100
      // --- ORANGE ---
      '#E65100', // 900
      '#FFD180', // A100
      // --- DEEP ORANGE ---
      '#BF360C', // 900
      '#FF9E80', // A100
      // --- BROWN ---
      '#3E2723' // 900
    ]
  },
  strongPalette: {
    // Based on https://learnui.design/tools/data-color-picker.html
    base: [
      '#003f5c',
      '#2f4b7c',

      '#004c6d',
      '#255e7e',
      '#3d708f',
      '#5383a1',
      '#6996b3',
      '#7faac6',
      '#94bed9',
      '#abd2ec',
      '#c1e7ff'
    ],
    stress: [
      '#665191',
      '#a05195',
      '#d45087',
      '#f95d6a',
      '#ff7c43',
      '#ffa600',

      '#00876c',
      '#439981',
      '#6aaa96',
      '#8cbcac',
      '#aecdc2',
      '#cfdfd9',
      '#f1f1f1',
      '#f1d4d4',
      '#f0b8b8',
      '#ec9c9d',
      '#e67f83',
      '#de6069',
      '#d43d51'
    ]
  }
};
